"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, useEffect } from "react";
import ProductGrid from "./ProductGrid";
import { Suspense } from "react";
import { ProductGridSkeleton } from "@/components/ui/skeleton";
import { useRouter, usePathname } from "next/navigation";
import ResponsiveContainer from "@/features/product-listing/ResponsiveContainer";
import FAQ from "@/components/ui/faq";
import parse from "html-react-parser";
interface InitialProductType {
  label?: string;
  name?: string;
  metadata?: {
    content?: string;
    faq?: unknown[];
    [key: string]: unknown;
  };
  faq?: unknown[];
  [key: string]: unknown;
}
interface ProductCategoriesProps {
  initialProductType: InitialProductType;
  slug: string;
  initialProductsPromise?: Promise<unknown>;
  initialNavigationData?: Record<string, unknown>;
  searchParams: {
    [key: string]: string | string[] | undefined;
  };
}
const ProductCategoriesComponent = t0 => {
  const $ = _c(37);
  const {
    initialProductType,
    slug,
    initialProductsPromise,
    initialNavigationData,
    searchParams: searchParamsProp
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const isThemeCake = slug === "theme-cakes";
  let t1;
  if ($[0] !== initialProductType || $[1] !== pathname || $[2] !== router || $[3] !== searchParamsProp?.category_id || $[4] !== searchParamsProp?.id) {
    t1 = () => {
      if (initialProductType?.id && !searchParamsProp?.id && !searchParamsProp?.category_id) {
        const isLabel = String(initialProductType.id).startsWith("label-") || initialProductType.is_navbar_label;
        const cleanId = String(initialProductType.id).replace("label-", "");
        if (cleanId && !isNaN(Number(cleanId))) {
          const params = new URLSearchParams(window.location.search);
          if (isLabel) {
            params.set("category_id", cleanId);
          } else {
            params.set("id", cleanId);
          }
          router.replace(`${pathname}?${params.toString()}`, {
            scroll: false
          });
        }
      }
    };
    $[0] = initialProductType;
    $[1] = pathname;
    $[2] = router;
    $[3] = searchParamsProp?.category_id;
    $[4] = searchParamsProp?.id;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== initialProductType || $[7] !== pathname || $[8] !== router || $[9] !== searchParamsProp) {
    t2 = [initialProductType, searchParamsProp, pathname, router];
    $[6] = initialProductType;
    $[7] = pathname;
    $[8] = router;
    $[9] = searchParamsProp;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  useEffect(t1, t2);
  let params_0;
  if ($[11] !== initialProductType || $[12] !== isThemeCake || $[13] !== searchParamsProp) {
    params_0 = new URLSearchParams();
    if (searchParamsProp) {
      Object.entries(searchParamsProp).forEach(t3 => {
        const [key, value] = t3;
        if (value !== undefined) {
          params_0.set(key, Array.isArray(value) ? value[0] : value);
        }
      });
    }
    params_0.set("is_theme_cake", isThemeCake.toString());
    const isNavbarLabel = searchParamsProp?.is_navbar_label === "true" || searchParamsProp?.category_id !== undefined || initialProductType?.is_navbar_label || initialProductType?.id && String(initialProductType.id).startsWith("label-");
    if (isNavbarLabel) {
      params_0.set("is_navbar_label", "true");
    }
    $[11] = initialProductType;
    $[12] = isThemeCake;
    $[13] = searchParamsProp;
    $[14] = params_0;
  } else {
    params_0 = $[14];
  }
  const searchParams = params_0;
  let t3;
  if ($[15] !== initialProductType?.label || $[16] !== initialProductType?.metadata?.content || $[17] !== initialProductType?.metadata?.content_heading || $[18] !== initialProductType?.metadata?.faq || $[19] !== initialProductType?.metadata?.meta_heading || $[20] !== initialProductType?.name || $[21] !== slug) {
    t3 = () => (initialProductType?.metadata?.content || initialProductType?.metadata?.faq) && <>{initialProductType?.metadata?.content && <section className="flex flex-col w-full max-w-[1440px] mx-auto items-start justify-between px-3 lg:px-[45px] py-5 bg-gray-50"><h2 className="font-medium font-outfit lg:text-[24px] text-[#3E3D4D] text-2xl">{initialProductType?.metadata?.content_heading || initialProductType?.metadata?.meta_heading || initialProductType?.label || initialProductType?.name || slug}</h2><div className="font-normal font-outfit lg:text-[16px] text-[#3E3D4D] text-base py-5">{parse(initialProductType?.metadata?.content || "")}</div></section>}{initialProductType?.metadata?.faq && <FAQ faqs={initialProductType?.metadata?.faq} className="w-full max-w-[1440px] mx-auto px-3 lg:px-[45px] py-5 bg-gray-50 max-lg:pb-14" />}</>;
    $[15] = initialProductType?.label;
    $[16] = initialProductType?.metadata?.content;
    $[17] = initialProductType?.metadata?.content_heading;
    $[18] = initialProductType?.metadata?.faq;
    $[19] = initialProductType?.metadata?.meta_heading;
    $[20] = initialProductType?.name;
    $[21] = slug;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  let t4;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ProductGridSkeleton />;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== initialNavigationData || $[25] !== initialProductType || $[26] !== initialProductsPromise || $[27] !== isThemeCake || $[28] !== searchParams || $[29] !== searchParamsProp) {
    t5 = <Suspense fallback={t4}><ProductGrid initialProductsPromise={initialProductsPromise} searchParams={searchParams} searchParamsProp={searchParamsProp} isThemeCake={isThemeCake} selectedProductType={initialProductType} initialNavigationData={initialNavigationData} /></Suspense>;
    $[24] = initialNavigationData;
    $[25] = initialProductType;
    $[26] = initialProductsPromise;
    $[27] = isThemeCake;
    $[28] = searchParams;
    $[29] = searchParamsProp;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  let t6;
  if ($[31] !== initialNavigationData || $[32] !== initialProductType || $[33] !== searchParamsProp || $[34] !== t3 || $[35] !== t5) {
    t6 = <ResponsiveContainer selectedProductType={initialProductType} initialNavigationData={initialNavigationData} searchParams={searchParamsProp} renderFooter={t3}>{t5}</ResponsiveContainer>;
    $[31] = initialNavigationData;
    $[32] = initialProductType;
    $[33] = searchParamsProp;
    $[34] = t3;
    $[35] = t5;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  return t6;
};
export default ProductCategoriesComponent;